import React, { PropsWithChildren, useEffect, useState } from "react";
import { Button, Checkbox, Modal } from "antd";

function IssueModal({
  visible,
  onClose,
  setVisible,
  showCheckbox,
  storageKey,
  children,
}: PropsWithChildren<Props>) {
  const DEFAULT_CHECKED = true;

  const [checked, setChecked] = useState(DEFAULT_CHECKED);

  // Function to handle closing and setting preference
  const handleCheck = (isChecked: boolean) => {
    setChecked(isChecked);
    console.log("SETTING LOCAL STORAGE:", isChecked.toString());
    // localStorage.setItem(storageKey, isChecked.toString());
  };

  return (
    <Modal
      centered
      visible={visible}
      closable={false}
      //   onCancel={() => setVisible(false)}
      footer={null}
      width={700}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          paddingBlock: "20px",
          paddingInline: "10px",
        }}
      >
        {children}
        {showCheckbox && (
          <Checkbox
            checked={checked}
            style={{
              marginTop: "20px",
              fontSize: "16px",
              color: "black",
            }}
            onChange={(e) => {
              handleCheck(e.target.checked);
            }}
          >
            次回以降表示しない
          </Checkbox>
        )}
        <Button
          onClick={() => {
            setVisible(false);
            localStorage.setItem(storageKey, checked.toString());
          }}
          style={{
            width: "150px",
            height: "36px",
            fontSize: "16px",
            backgroundColor: "#007AFF",
            color: "white",
            borderRadius: "5px",
            marginTop: "10px",
          }}
          id="modalButton"
        >
          閉じる
        </Button>
      </div>
    </Modal>
  );
}

export default IssueModal;

// Types
type Props = {
  visible: boolean;
  onClose?: () => void;
  setVisible: (isVisible: boolean) => void;
  showCheckbox: boolean;
  storageKey: string;
};
